module.exports = "/packs/images/homepage/whatson/learn_to_swim_retina~048098310bea722da1b0979ab5430012.jpg";